import { createStore } from 'vuex';
import auth from './auth';
import organizations from './organizations';
import users from './users';
import videos from './videos';
import userPreferences from './userPreferences';

export default createStore({
  modules: {
    auth,
    organizations,
    users,
    videos,
    userPreferences,
  },
});
